import { useCallback } from 'react';

/**
 * Hook for authentication utilities.
 * Returns functions to get auth tokens and headers for API calls.
 */
export function useAuth() {
  const getAuthToken = useCallback(() => {
    return localStorage.getItem('authToken') || localStorage.getItem('token');
  }, []);

  const getAuthHeaders = useCallback((): Record<string, string> => {
    const token = getAuthToken();
    return {
      'Content-Type': 'application/json',
      ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
    };
  }, [getAuthToken]);

  const isAuthenticated = useCallback(() => {
    return !!getAuthToken();
  }, [getAuthToken]);

  return {
    getAuthToken,
    getAuthHeaders,
    isAuthenticated,
  };
}

/**
 * Get auth headers for API calls (non-hook version for use outside components).
 */
export function getAuthHeaders(): Record<string, string> {
  const token = localStorage.getItem('authToken') || localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
  };
}

/**
 * Get auth token from localStorage.
 */
export function getAuthToken(): string | null {
  return localStorage.getItem('authToken') || localStorage.getItem('token');
}
